import * as types from './../types/arquivos';

const INITIAL_STATE = {
  loading: false,
  arquivos: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ARQUIVOS:
      return { ...state, arquivos: action.payload };

    case types.LOADING_ARQUIVOS:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};